import { render, staticRenderFns } from "./DateDifferenceInput.vue?vue&type=template&id=c13897ae"
import script from "./DateDifferenceInput.vue?vue&type=script&lang=js"
export * from "./DateDifferenceInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports